/**
 * @page store入口
 * @author yuxin.zhang
 * @Date 2018/7/2
 */
import EarnStore from './earnStore';
import EddKycStore from './eddKycStore';
import EmailSettingStore from './emailSettingStore';
import GuideStore from './guideStore';
import LoadingStore from './loadingStore';
import OkjpKycStore from './okjpKycStore';
import OkjpKycStoreCorporate from './okjpKycStoreCorporate';
import ProfileStore from './profileStore';
import RechargeCoinStore from './rechargeCoinStore';
import ReportStore from './reportStore';
import SecurityStore from './securityStore';
import ValuationUnitStore from './valuationUnitStore';
import VerifyStore from './verifyStore';
import WithdrawCoinStore from './withdrawCoinStore';

class RootStore {
  constructor() {
    this.loadingStore = new LoadingStore(this);
    this.guideStore = new GuideStore(this);
    this.verifyStore = new VerifyStore(this);
    this.profileStore = new ProfileStore(this);
    this.securityStore = new SecurityStore(this);
    this.rechargeCoinStore = new RechargeCoinStore(this);
    this.withdrawCoinStore = new WithdrawCoinStore(this);
    this.valuationUnitStore = new ValuationUnitStore(this);
    this.okjpKycStore = new OkjpKycStore(this);
    this.okjpKycStoreCorporate = new OkjpKycStoreCorporate(this);
    this.eddKycStore = new EddKycStore(this);
    this.reportStore = new ReportStore(this);
    this.emailSettingStore = new EmailSettingStore(this);
    this.earnStore = new EarnStore(this);
  }
}

export default new RootStore();
